// frontend/src/contexts/OnboardingContext.jsx
import React, { createContext, useState, useEffect } from 'react';
import api from '../utils/api';

// Shape of our context: holds the current step and a setter
export const OnboardingContext = createContext({
  onboardingStep: null,            // null => not loaded yet
  onboardingLoading: true,
  setOnboardingStepIfNotComplete: () => {},
});

export function OnboardingProvider({ children }) {
  const [onboardingStep, setOnboardingStepIfNotComplete] = useState(null);
  const [onboardingLoading, setOnboardingLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function fetchStep(){
      try {
        const res = await api.get('/api/user/onboarding');
        if (!cancelled) {
          setOnboardingStepIfNotComplete(res?.data?.step ?? null);
        }
      } catch (err) {
        console.error('Failed to load onboarding step:', err);
      } finally {
        if (!cancelled) setOnboardingLoading(false);
      }
    }
    fetchStep();
    return () => { cancelled = true; };
  }, []);

  return (
    <OnboardingContext.Provider value={{ onboardingStep, onboardingLoading, setOnboardingStepIfNotComplete }}>
      {children}
    </OnboardingContext.Provider>
  );
}